import { useSelector,useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { arrayNameByLang, appStorageKey } from '../utils/global.js'
import {useLang} from '../hooks/'
import { useEffect, useState } from "react";
import {setCurrentCompany} from '../store/currentCompanySlice.js'
import {setCurrentBranch} from '../store/currentBranchSlice.js'
import { setLang } from "../store/langSlice.js";

const useTenant = () => {
    const dispatch = useDispatch();
    const { i18n } = useTranslation('global');

    const {langSelected} = useLang();

    const [loading,setLoading] = useState(true)
    const [tenant,setTenant] = useState({});
    const [companiesList,setCompaniesList] = useState([]);
    const [tenantId,setTenantId] = useState();
    const [tenantUsername,setTenantUsername] = useState();
    const [allAppSetting,setAllAppSetting] = useState();
    const [initialCompanyName,setInitialCompanyName] = useState();
    const [initialCompanyId,setInitialCompanyId] = useState();
    const [getSettingsByCompanySelected,setSettingsByCompanySelected] = useState({});

    const companySelected  = useSelector((state)=>state.currentCompany)
    const branchSelected = useSelector((state)=>state.currentBranch)

    const safeParse = (value) => {
        if (!value) return null;
        try {
            return JSON.parse(value);
        } catch {
            return null;
        }
    };
    const isSelectionKey = (key, suffix) => key && key.endsWith(suffix);
    const getStoredSelection = (keys) => {
        let selected = null;
        let selectedTime = -1;
        for (const key of keys) {
            const value = safeParse(localStorage.getItem(key));
            if (!value?.value) continue;
            const updatedAt = Number(value?.updatedAt || 0);
            if (updatedAt >= selectedTime) {
                selected = value;
                selectedTime = updatedAt;
            }
        }
        return selected;
    };
    const getSelectionKeys = (suffix, eventKey, primaryKey) => {
        const keys = new Set();
        if (primaryKey) keys.add(primaryKey);
        if (eventKey && isSelectionKey(eventKey, suffix)) keys.add(eventKey);
        try {
            Object.keys(localStorage).forEach((key) => {
                if (isSelectionKey(key, suffix)) keys.add(key);
            });
        } catch {
        }
        return Array.from(keys);
    };
    const getPreferredLangValue = () => {
        try {
            return localStorage.getItem("preferredLang") || localStorage.getItem("i18nextLng") || localStorage.getItem("appLang");
        } catch {
            return null;
        }
    };
    const normalizeLangValue = (value) =>
        String(value || "").toLowerCase().startsWith("ar") ? "ar" : "en";
    const applyLang = (value) => {
        if (!value) return;
        const normalized = normalizeLangValue(value);
        if (normalized !== langSelected?.value) {
            dispatch(setLang({ value: normalized }));
        }
        if (i18n.language !== normalized) {
            i18n.changeLanguage(normalized);
        }
    };
    const getCompanyById = (id) => tenant?.companies?.filter(company => company._id === id)[0]
    const companyNameByLang =  (company) => company?.name?.filter((companyname) => companyname.lang === langSelected.value )[0]
    const currentCompany = getCompanyById(companySelected?.value)
    const getNameByLang = (nameList, fallback) => {
        if (!Array.isArray(nameList)) return fallback || '';
        return (
            nameList.find((n) => n?.lang === langSelected.value)?.text ||
            nameList.find((n) => n?.lang === 'ar')?.text ||
            nameList.find((n) => n?.lang === 'en')?.text ||
            nameList?.[0]?.text ||
            fallback ||
            ''
        );
    };

    const tenantCompaniesByLang = (lang) => {
        return tenant?.companies?.map( company => { 
                return {
                    companyId:company._id ,
                    companyName: arrayNameByLang(company.name,lang)
                }
            });
    }
    const companiesListHandler = () => tenantCompaniesByLang(langSelected.value)?.map( (item) => {
        return {label : item?.companyName?.text , value : item?.companyId }
    });

   // const [companiesList,setCompaniesList] = useState(companiesListHandller)

    const BranchesByCompanyId = (companyId) => tenant?.companies?.filter( (company) => company._id === companyId)[0]?.branches;

    const branchesList = BranchesByCompanyId(companySelected.value)?.map(branch => {
        const branchId = branch._id;
        let branchName = branch.name.find(name => name.lang === langSelected.value)?.text;
        if (!branchName) {
            branchName = branch.name.find(name => name.lang === 'ar')?.text || 'اسم غير متوفر';
        }
        return {
            label: branchName,
            value: branchId
        };
    });
useEffect(() => {
    const tenantHandler = () => safeParse(localStorage.getItem('tenant'));
    const nextTenant = tenantHandler();
    if(nextTenant){
        setTenant(nextTenant)
    }
},[]);    

useEffect(() => {
    if(Object.keys(tenant).length > 0) {
        setTenantId(tenant?._id);
        setTenantUsername(tenant?.username);
        setAllAppSetting(tenant?.setting?.appSetting);
        setInitialCompanyName(tenant?.companies[0]?.name[0]?.text);
        setInitialCompanyId(tenant?.companies[0]?.value);
        setSettingsByCompanySelected(currentCompany)
        const nextCompaniesList = companiesListHandler() || [];
        setCompaniesList(nextCompaniesList)
        const storedCompany = safeParse(localStorage.getItem(appStorageKey('selectedCompany')));
        const storedCompanyId = storedCompany?.value;
        const storedCompanyEntity = storedCompanyId ? getCompanyById(storedCompanyId) : null;
        if (storedCompanyEntity && storedCompanyId !== companySelected?.value) {
            dispatch(setCurrentCompany({
                name: getNameByLang(storedCompanyEntity?.name, storedCompany?.name),
                value: storedCompanyId
            }));
        } else if(!companySelected?.value && nextCompaniesList[0]?.value){
            dispatch(setCurrentCompany({name: nextCompaniesList[0]?.label,value: nextCompaniesList[0]?.value}));
        }
        setLoading(false);
    }
},[tenant, companySelected?.value, langSelected.value]);

useEffect(() => {
    if (!companySelected?.value) return;
    const companyBranches = BranchesByCompanyId(companySelected.value) || [];
    if (!companyBranches.length) return;
    const storedBranch = safeParse(localStorage.getItem(appStorageKey('selectedBranch')));
    const storedBranchId = storedBranch?.value;
    const storedBranchEntity = storedBranchId
        ? companyBranches.find((branch) => branch?._id === storedBranchId)
        : null;
    if (storedBranchEntity && storedBranchId !== branchSelected?.value) {
        dispatch(setCurrentBranch({
            name: getNameByLang(storedBranchEntity?.name, storedBranch?.name || 'الفرع'),
            value: storedBranchId
        }));
        return;
    }
    const currentBranchExists = companyBranches.some((branch) => branch?._id === branchSelected?.value);
    if (currentBranchExists) return;
    const nextBranch = companyBranches[0];
    const nextBranchName = arrayNameByLang(nextBranch?.name, langSelected.value)?.text
        || arrayNameByLang(nextBranch?.name, 'ar')?.text
        || 'الفرع';
    dispatch(setCurrentBranch({ name: nextBranchName, value: nextBranch?._id }));
}, [companySelected?.value, branchSelected?.value, tenant, langSelected.value]);

useEffect(() => {
    if (!tenant || !tenant?.companies?.length) return;
    const syncFromStorage = (eventKey) => {
        const companyKeys = getSelectionKeys(':selectedCompany', eventKey, appStorageKey('selectedCompany'));
        const storedCompany = getStoredSelection(companyKeys);
        const storedCompanyId = storedCompany?.value;
        const storedCompanyEntity = storedCompanyId ? getCompanyById(storedCompanyId) : null;
        if (storedCompanyEntity && storedCompanyId !== companySelected?.value) {
            dispatch(setCurrentCompany({
                name: getNameByLang(storedCompanyEntity?.name, storedCompany?.name),
                value: storedCompanyId
            }));
        }
        const effectiveCompanyId = storedCompanyEntity?._id || companySelected?.value;
        const companyBranches = effectiveCompanyId ? BranchesByCompanyId(effectiveCompanyId) || [] : [];
        const branchKeys = getSelectionKeys(':selectedBranch', eventKey, appStorageKey('selectedBranch'));
        const storedBranch = getStoredSelection(branchKeys);
        const storedBranchId = storedBranch?.value;
        const storedBranchEntity = storedBranchId
            ? companyBranches.find((branch) => branch?._id === storedBranchId)
            : null;
        if (storedBranchEntity && storedBranchId !== branchSelected?.value) {
            dispatch(setCurrentBranch({
                name: getNameByLang(storedBranchEntity?.name, storedBranch?.name || 'الفرع'),
                value: storedBranchId
            }));
        }
    };
    syncFromStorage();
    const handleStorage = (event) => {
        if (isSelectionKey(event.key, ':selectedCompany') || isSelectionKey(event.key, ':selectedBranch')) {
            syncFromStorage(event.key);
        }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
}, [tenant, langSelected.value, companySelected?.value, branchSelected?.value]);

useEffect(() => {
    const initialLang = getPreferredLangValue();
    applyLang(initialLang);
    const handleStorage = (event) => {
        if (event.key === "preferredLang" || event.key === "i18nextLng" || event.key === "appLang") {
            applyLang(event.newValue);
        }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
}, [dispatch, i18n, langSelected?.value]);

    return {
            loading,
            tenant,
            tenantId,
            tenantUsername,
            allAppSetting,
            initialCompanyName,
            initialCompanyId,
            companiesList,
            branchesList,
            tenantCompaniesByLang,
            BranchesByCompanyId,
            getCompanyById,
            companyNameByLang,
            getSettingsByCompanySelected,
            companySelected,
            branchSelected
        }
}

export default useTenant
